var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      class: _vm.variant,
      style: { "min-width": _vm.minWidth },
      attrs: {
        id: _vm.id,
        "data-backdrop": _vm.dataBackdrop,
        "data-target": _vm.dataTarget,
        "data-toggle": _vm.dataToggle,
        type: _vm.type
      },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.click.apply(null, arguments)
        }
      }
    },
    [
      _vm.i
        ? _c("i", {
            staticClass: "mr-2",
            class: _vm.i + " " + _vm.classIcon,
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.click.apply(null, arguments)
              }
            }
          })
        : _vm._e(),
      _vm._t("default", function() {
        return [_vm._v(_vm._s(_vm.text))]
      }),
      _vm.iright
        ? _c("i", { staticClass: "mr-2", class: _vm.iright })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }